import React, { useMemo, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, Paper, Tooltip } from '@material-ui/core';
import ChatIcon from '@material-ui/icons/Chat';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  floatingButton: {
    position: 'fixed',
    right: theme.spacing(3),
    bottom: theme.spacing(3),
    width: 56,
    height: 56,
    borderRadius: '50%',
    zIndex: 1400,
    backgroundColor: '#3C7DDD',
    color: '#fff',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
    '&:hover': {
      backgroundColor: '#2f66b7',
    },
    '& svg': {
      fontSize: 28,
    },
    [theme.breakpoints.down('md')]: {
      right: theme.spacing(2),
      bottom: theme.spacing(2),
      width: 50,
      height: 50,
      '& svg': {
        fontSize: 24,
      },
    },
    [theme.breakpoints.down('xs')]: {
      right: theme.spacing(1.5),
      bottom: theme.spacing(1.5),
      width: 44,
      height: 44,
      '& svg': {
        fontSize: 21,
      },
    },
  },
  chatPanel: {
    position: 'fixed',
    right: 24,
    bottom: 92,
    width: 'min(95vw, 420px)',
    height: 'min(72vh, 620px)',
    maxHeight: 'calc(100vh - 110px)',
    borderRadius: 12,
    overflow: 'hidden',
    zIndex: 1400,
    [theme.breakpoints.down('sm')]: {
      right: 12,
      bottom: 82,
      width: 'calc(100vw - 24px)',
      height: 'min(68vh, 560px)',
      maxHeight: 'calc(100vh - 95px)',
    },
  },
  closeButton: {
    position: 'absolute',
    top: 8,
    right: 8,
    zIndex: 2,
    padding: 6,
    backgroundColor: 'rgba(255, 255, 255, 0.85)',
    '& svg': {
      fontSize: 20,
    },
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 1)',
    },
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 0,
  },
}));

const ChatbotWidget = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const chatbotUrl = useMemo(() => {
    const globalConfig = window && window.global ? window.global : {};
    const envUrl = process.env.REACT_APP_COPILOT_WEBCHAT_URL || '';
    const globalUrl = globalConfig.copilotWebchatURL || '';
    const fallbackUrl = 'https://copilotstudio.microsoft.com/environments/Default-766ed5d1-7eb1-46ef-bc6f-fe163f2e86b2/bots/cr971_echo/webchat?__version__=2';
    const candidateUrl = envUrl || globalUrl || fallbackUrl;

    // Protect local dev from unresolved template placeholders like "{{ getenv ... }}".
    if (candidateUrl.includes('{{') || !candidateUrl.startsWith('http')) {
      return fallbackUrl;
    }

    return candidateUrl;
  }, []);

  if (!chatbotUrl) {
    return null;
  }

  return (
    <>
      {open && (
        <Paper elevation={6} className={classes.chatPanel}>
          <IconButton
            aria-label="Close chatbot"
            className={classes.closeButton}
            onClick={() => setOpen(false)}
          >
            <CloseIcon />
          </IconButton>
          <iframe
            title="Deviare Copilot Chatbot"
            src={chatbotUrl}
            className={classes.iframe}
            allow="clipboard-write"
          />
        </Paper>
      )}

      <Tooltip title="Chat with assistant" placement="left">
        <IconButton
          className={classes.floatingButton}
          aria-label="Open chatbot"
          onClick={() => setOpen(true)}
        >
          <ChatIcon />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default ChatbotWidget;
